// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2l9L4","rootSuccess":"CompleteLink_rootSuccess__ataTm","rootFailure":"CompleteLink_rootFailure__18eJb","isDisabled":"CompleteLink_isDisabled__22xdB"};